import State from './types'

const initialState: State = {
    count: undefined,
    guestFavoriteListings: [],
}

export default initialState
